import { devtools } from 'zustand/middleware';

import { create } from '@app/store/zustand/helpers/create';

type LeaderboardData = {
    leaderboardKey?: Array<string | number | boolean | undefined>;
};
interface LeaderboardState extends LeaderboardData {
    setLeaderboardKey: (leaderboardKey?: Array<string | number | boolean | undefined>) => void;
}

const initialState: LeaderboardData = {
    leaderboardKey: [],
};

export const useFantasyLeaderboardStore = create<LeaderboardState>()(
    devtools(
        (set) => ({
            ...initialState,
            setLeaderboardKey: (leaderboardKey) => set({ leaderboardKey }),
        }),
        { name: 'fantasy-leaderboard-data-store' },
    ),
);
